import DisGENETSchemaFlow from './DisGENETSchemaFlow';

function AboutSchema() {
  return (
    <div>
      <h2>The DISGENET schema</h2>
      <div className="mb-2 divider" />
      <p>
        DISGENET data is standardized using community-supported standards and ontologies. <br />
        The data can be filtered and selected by using different attributes, metrics and scores available for
        the genes, variants, diseases and their associations.
      </p>
      <DisGENETSchemaFlow />
      <div className="divider" />
    </div>
  );
}

export default AboutSchema;
